import { useEffect, useMemo, useState } from "react";
import { Fragment } from "react";
import {
  Button,
  Col,
  Popover,
  PopoverBody,
  Row,
  FormGroup,
  Label,
} from "reactstrap";
import { Input } from "reactstrap";
import { Multiselect } from "react-widgets";
import { useLazyQuery, useMutation, useQuery } from "@apollo/client";
import {
  CHECK_USER_STATUS,
  NEW_SEARCH,
  QUERY_GET_ALL_COUNTRIES,
  QUERY_GET_ALL_SDGS,
  QUERY_GET_ALL_TARGET,
} from "../../../../queries";
import {
  GET_ALL_ACTIVITY_FIELDS,
  GET_ALL_COLLABORATION_NEEDS,
  GET_ALL_REVENUE_CATEGORIES,
  GET_ORG_RESULT,
  GET_SUPPORTER_INFO,
} from "../queries";
import CsoResult from "./CsoResult";
import { sendGAEvent } from "../../../../utils";
import {
  GET_ALL_CERTIFICATIONS,
  GET_ALL_NETWORKS,
} from "../../../../queries/networksAndCertifications";
import AddTitleModal from "./SearchCondition/AddTitleModal";
import ListModal from "./SearchCondition/ListModal";
import { SAVE_SEARCH_LOG } from "../mutations";
import animetionLogo from "../../../../assets/utils/images/animetion_logo.gif";
import "./index.scss";
import {
  useUserEmail,
  useLoginStatus,
} from "../../../../Layout/AppMain/LoginStatusContext";
import { fi } from "date-fns/locale";

const FilterItemChip = ({ label, active, onClick }) => {
  return (
    <button
      onClick={onClick}
      type="button"
      style={{
        backgroundColor: active ? "#44CAE1" : "#C4C4C4",
        color: "#ffffff",
        fontSize: "10px",
        padding: "7px 12px",
        marginRight: "4px",
        marginBottom: "4px",
        border: "none",
        borderRadius: "5px",
      }}
    >
      {label}
    </button>
  );
};

const searchInputInitialState = {
  freeText: "",
  country: [],
  sdgs: [],
  activityFields: [],
  collaborationNeeds: [],
  stakeholders: [],
  revenueCategories: [],
  networks: [],
  certifications: [],
};

const SearchCSO = (props) => {
  const { activeKey } = props;
  const [popoverOpen, setPopoverOpen] = useState(false);
  const [searchInput, setSearchInput] = useState(searchInputInitialState);
  const [searchContext, setSearchContext] = useState("");
  const [result, setResult] = useState([]);
  const [loadingSearch, setLoadingSearch] = useState(false);
  const [paginateOptions, setPaginateOptions] = useState({
    first: 8,
    after: "",
  });
  const [queryParams, setQueryParams] = useState({});
  const [storeSearchConditionModal, setStoreSearchConditionModal] =
    useState(false);
  const [storedSearchConditionModal, setStoredSearchConditionModal] =
    useState(false);

  const [saveSearchCondition, { loading: savingSearchCondition }] =
    useMutation(SAVE_SEARCH_LOG);

  useEffect(() => {
    localStorage.setItem("tabActive", activeKey);
    sendGAEvent(
      "pageview",
      "/#/dashboards/organization-partnership/search_tab"
    );
  }, [activeKey]);

  const { loading: loadingSdgs, data: dataSdgs } = useQuery(QUERY_GET_ALL_SDGS);
  const { loading: loadingActivityFields, data: dataActivityFields } = useQuery(
    GET_ALL_ACTIVITY_FIELDS
  );
  const { loading: loadingCollaborationNeeds, data: dataCollaborationNeeds } =
    useQuery(GET_ALL_COLLABORATION_NEEDS);

  const { loading: loadingTarget, data: allTarget } =
    useQuery(QUERY_GET_ALL_TARGET);

  const { loading: loadingRevenueCategories, data: allRevenueCategories } =
    useQuery(GET_ALL_REVENUE_CATEGORIES);

  const { data: allNetworksData, loading: loadingNetworks } =
    useQuery(GET_ALL_NETWORKS);
  const { data: allCertificationsData, loading: loadingCertification } =
    useQuery(GET_ALL_CERTIFICATIONS);

  const networksOptions = allNetworksData?.allNetwork?.edges?.map(
    (network) => ({
      value: network?.node?.id,
      label: network?.node?.title,
    })
  );

  const certificationsOptions =
    allCertificationsData?.allThirdPartyCertificate?.edges?.map(
      (certification) => ({
        value: certification?.node?.id,
        label: certification?.node?.title,
      })
    );

  const sdgsOptions = dataSdgs?.allSdgs?.edges?.map((sdg, idx) => {
    return {
      value: sdg?.node?.id,
      label: `${idx + 1}. ${sdg?.node?.title}`,
      title: sdg?.node?.title,
    };
  });

  const activityFieldsOptions =
    dataActivityFields?.allActivityfields?.edges?.map((activityField, idx) => ({
      value: activityField?.node?.id,
      label: activityField?.node?.name,
    }));

  const collaborationNeedsOptions =
    dataCollaborationNeeds?.allCollaborationNeeds?.edges?.map(
      (collaborationNeed, idx) => ({
        value: collaborationNeed?.node?.id,
        label: collaborationNeed?.node?.title,
      })
    );

  const targetOptions = allTarget?.allTarget?.edges?.map((target, idx) => ({
    value: target?.node?.id,
    label: target?.node?.name,
  }));

  const revenueCategoriesOptions =
    allRevenueCategories?.allRevenueCategory?.edges?.map(
      (revenueCategory, idx) => ({
        value: revenueCategory?.node?.id,
        label: revenueCategory?.node?.scale,
      })
    );

  const filterItems = useMemo(() => {
    return [
      {
        label: "SDGsのGoalから選ぶ",
        name: "sdgs",
        options: sdgsOptions,
        visible: !loadingSdgs,
      },
      {
        label: "活動分野から選ぶ",
        name: "activityFields",
        options: activityFieldsOptions,
        visible: !loadingActivityFields,
      },
      {
        label: "連携ニーズ/連携内容から選ぶ",
        name: "collaborationNeeds",
        options: collaborationNeedsOptions,
        visible: !loadingCollaborationNeeds,
      },
      {
        label: "対象としたい課題当事者から選ぶ",
        name: "stakeholders",
        options: targetOptions,
        visible: !loadingTarget,
      },
      {
        label: "連携先CSO の組織規模から選ぶ",
        name: "revenueCategories",
        options: revenueCategoriesOptions,
        visible: !loadingRevenueCategories,
      },
      {
        label: "ネットワークから選ぶ",
        name: "networks",
        options: networksOptions,
        visible: !loadingNetworks,
      },
      {
        label: "第三者認証から選ぶ",
        name: "certifications",
        options: certificationsOptions,
        visible: !loadingCertification,
      },
    ];
  }, [
    sdgsOptions,
    loadingSdgs,
    activityFieldsOptions,
    loadingActivityFields,
    collaborationNeedsOptions,
    loadingCollaborationNeeds,
    targetOptions,
    loadingTarget,
    revenueCategoriesOptions,
    loadingRevenueCategories,
    networksOptions,
    loadingNetworks,
    certificationsOptions,
    loadingCertification,
  ]);

  const availableCountries = useQuery(QUERY_GET_ALL_COUNTRIES);

  const indexedFilterItemsOptions = useMemo(() => {
    const rawOptions = {
      ...(sdgsOptions && {
        sdgs: sdgsOptions.map((item) => {
          return {
            value: item.value,
            label: item.title,
          };
        }),
      }),
      ...(activityFieldsOptions && { activityFields: activityFieldsOptions }),
      ...(collaborationNeedsOptions && {
        collaborationNeeds: collaborationNeedsOptions,
      }),
      ...(targetOptions && { stakeholders: targetOptions }),
      ...(revenueCategoriesOptions && {
        revenueCategories: revenueCategoriesOptions,
      }),
      ...(networksOptions && { networks: networksOptions }),
      ...(certificationsOptions && { certifications: certificationsOptions }),
    };
    const keys = Object.keys(rawOptions);
    const options = keys.reduce((acc, key) => {
      return {
        ...acc,
        [key]: rawOptions[key].reduce((acc, item) => {
          return {
            ...acc,
            [item.value]: item.label,
          };
        }, {}),
      };
    }, {});
    return Object.keys(options).reduce((acc, key) => {
      return {
        ...acc,
        ...options[key],
      };
    }, {});
  }, [
    sdgsOptions,
    activityFieldsOptions,
    collaborationNeedsOptions,
    targetOptions,
    revenueCategoriesOptions,
    networksOptions,
    certificationsOptions,
  ]);

  const filterContext = useMemo(() => {
    let result = [];
    const keys = Object.keys(searchInput);
    keys.forEach((key) => {
      if (typeof searchInput[key] === "string" && searchInput[key] !== "") {
        result.push(searchInput[key]);
      } else {
        if (searchInput[key] !== null && searchInput[key].length > 0) {
          result = [
            ...result,
            ...searchInput[key].map((item) => indexedFilterItemsOptions[item]),
          ];
        }
      }
    });
    return result.join(" ") === "" ? "" : result.join(" ");
  }, [searchInput, indexedFilterItemsOptions]);

  function cleanSentence(sentence) {
    // Remove multiple spaces
    const cleanedSentence = sentence.replace(/\s+/g, " ");

    // Remove leading whitespace
    const trimmedSentence = cleanedSentence.trim();

    return trimmedSentence;
  }

  const loginStatus = useLoginStatus();
  const includeIsWished = loginStatus !== "";

  const generateFilterContext = (filterObj = {}, countries = []) => {
    const obj = Object.keys(filterObj).length > 0 ? filterObj : searchInput;
    const query = {
      name: obj.freeText,
      sdgs: obj.sdgs?.map((item) => item),
      country:
        countries.length > 0 ? countries : obj.country?.map((item) => item.id),
      collaborationNeeds: obj.collaborationNeeds?.map((item) => item),
      activityFields: obj.activityFields?.map((item) => item),
      stakeholders: obj.stakeholders?.map((item) => item),
      revenueCategories: obj.revenueCategories?.map((item) => item),
      networks: obj.networks?.map((item) => item),
      thirdPartyCertification: obj.certifications?.map((item) => item),
      includeIsWished: includeIsWished,
    };

    return {
      ...Object.fromEntries(
        Object.entries(query).filter(([key, value]) => {
          if (typeof value === "string") {
            return cleanSentence(value) !== "";
          }
          if (Array.isArray(value)) {
            return value.length > 0;
          }
          return value !== undefined && value !== null;
        })
      ),
    };
  };

  const generateStringContext = (filterObj = {}) => {
    let accRes = [];
    const keys = Object.keys(filterObj);
    keys.forEach((key) => {
      if (typeof filterObj[key] === "string" && filterObj[key] !== "") {
        accRes.push(filterObj[key]);
      } else {
        if (filterObj[key].length > 0) {
          accRes = [
            ...accRes,
            ...filterObj[key].map((item) => indexedFilterItemsOptions[item]),
          ];
        }
      }
    });
    return accRes.join(" ") === "" ? null : accRes.join(" ");
  };

  const handleChangeFreeText = (e) => {
    const { name, value } = e.target;
    setSearchInput((prev) => {
      return {
        ...prev,
        [name]: value,
      };
    });
  };

  const handleClickFilterItem = ({ filterName, filterValue }) => {
    setSearchInput((prev) => {
      const newFilter = prev[filterName].includes(filterValue)
        ? prev[filterName].filter((item) => item !== filterValue)
        : [...prev[filterName], filterValue];
      return {
        ...prev,
        [filterName]: newFilter,
      };
    });
  };
  console.log("search input", searchInput);

  const toggle = () => setPopoverOpen(!popoverOpen);

  const [
    fetchSearchResult,
    { loading: loadingSearchResult, data: dataSearchResult },
  ] = useLazyQuery(NEW_SEARCH, {
    onCompleted: (data) => {
      if (paginateOptions.after === "") {
        setResult(data.searchOrg?.edges?.map((item) => item?.node));
      } else {
        setResult((prev) => {
          return [...prev, ...data.searchOrg?.edges?.map((item) => item?.node)];
        });
      }
      setPaginateOptions((prev) => {
        return {
          after: data.searchOrg?.pageInfo?.endCursor,
        };
      });
    },
    variables: {
      // ...generateFilterContext(searchInput),
    },
  });

  const [
    getSupporterInfo,
    {
      data: supporterInfoData,
      loading: loadingSupporterInfo,
      error: supporterInfoError,
    },
  ] = useLazyQuery(GET_SUPPORTER_INFO, {
    onCompleted: (data) => {
      //   const node = data?.mySupporterInfo?.edges?.[0]?.node;
      //   const collaborationNeeds = node?.collaborationNeeds?.edges;
      //   const focusedSdges = node?.focusedSdges?.edges;
      //   const focusedStakeholders = node?.focusedStakeholders?.edges;
      //   const interestingActivity = node?.interestingActivity?.edges;
      //   if (collaborationNeeds?.length > 0) {
      //     setSearchInput((prev) => {
      //       return {
      //         ...prev,
      //         collaborationNeeds: collaborationNeeds.map(
      //           (item) => item?.node?.id
      //         ),
      //       };
      //     });
      //   }
      //   if (focusedSdges?.length > 0) {
      //     setSearchInput((prev) => {
      //       return {
      //         ...prev,
      //         sdgs: focusedSdges.map((item) => item?.node?.id),
      //       };
      //     });
      //   }
      //   if (focusedStakeholders?.length > 0) {
      //     setSearchInput((prev) => {
      //       return {
      //         ...prev,
      //         stakeholders: focusedStakeholders.map((item) => item?.node?.id),
      //       };
      //     });
      //   }
      //   if (interestingActivity?.length > 0) {
      //     setSearchInput((prev) => {
      //       return {
      //         ...prev,
      //         activityFields: interestingActivity.map((item) => item?.node?.id),
      //       };
      //     });
      //   }
      //   console.log(searchInput);
      //   fetchSearchResult({
      //     variables: {
      //       ...generateStringContext(searchInput),
      //       first: 8,
      //       after: "",
      //       includeIsWished: true,
      //     },
      //   });
    },
  });

  const handleSearchSupporterData = async () => {
    try {
      setResult([]);
      const data = await getSupporterInfo();
      const node = data?.data?.mySupporterInfo?.edges?.[0]?.node;
      const collaborationNeeds = node?.collaborationNeeds?.edges;
      const focusedSdges = node?.focusedSdges?.edges;
      const focusedStakeholders = node?.focusedStakeholders?.edges;
      const interestingActivity = node?.interestingActivity?.edges;
      const newParams = {
        ...(collaborationNeeds?.length > 0 && {
          collaborationNeeds: collaborationNeeds.map((item) => item?.node?.id),
        }),
        ...(focusedSdges?.length > 0 && {
          sdgs: focusedSdges.map((item) => item?.node?.id),
        }),
        ...(focusedStakeholders?.length > 0 && {
          stakeholders: focusedStakeholders.map((item) => item?.node?.id),
        }),
        ...(interestingActivity?.length > 0 && {
          activityFields: interestingActivity.map((item) => item?.node?.id),
        }),
      };
      setSearchInput((prev) => ({
        ...(collaborationNeeds?.length > 0 && {
          collaborationNeeds: collaborationNeeds.map((item) => item?.node?.id),
        }),
        ...(focusedSdges?.length > 0 && {
          sdgs: focusedSdges.map((item) => item?.node?.id),
        }),
        ...(focusedStakeholders?.length > 0 && {
          stakeholders: focusedStakeholders.map((item) => item?.node?.id),
        }),
        ...(interestingActivity?.length > 0 && {
          activityFields: interestingActivity.map((item) => item?.node?.id),
        }),
      }));
      fetchSearchResult({
        variables: {
          ...generateFilterContext(searchInput),
          ...newParams,
          first: 8,
          after: "",
          includeIsWished: true,
        },
      });
    } catch (err) {
      console.error(err);
    }
  };

  const onCsoWishCreated = (csoId) => {
    setResult((prev) => {
      return prev.map((item) => {
        return {
          ...item,
          ...(item.id === csoId && {
            isWished: true,
          }),
        };
      });
    });
  };

  const onCsoWishDeleted = (csoId) => {
    setResult((prev) => {
      return prev.map((item) => {
        return {
          ...item,
          ...(item.id === csoId && {
            isWished: false,
          }),
        };
      });
    });
  };

  const { data: checkUserStatus } = useQuery(CHECK_USER_STATUS, {
    variables: {
      email: useUserEmail(),
    },
  });

  const canEdit =
    checkUserStatus?.allUsers?.edges[0]?.node?.supporterRole === "can_edit" ||
    checkUserStatus?.allUsers?.edges[0]?.node?.supporterRole === "CAN_EDIT";

  return (
    <Fragment>
      <AddTitleModal
        open={storeSearchConditionModal}
        setOpen={() => {
          setStoreSearchConditionModal((prev) => !prev);
        }}
        handleSave={(title) => {
          saveSearchCondition({
            variables: {
              title,
              memo: searchContext,
              freeWord: searchInput.freeText,
              country: searchInput.country,
              activityFields: searchInput.activityFields,
              collaborationNeeds: searchInput.collaborationNeeds,
              csoNetworks: searchInput.networks,
              csoThirdPartyCertifications: searchInput.certifications,
              scaleAverages: searchInput.revenueCategories,
              sdgs: searchInput.sdgs,
              targets: searchInput.stakeholders,
            },
          });
        }}
      />
      <ListModal
        open={storedSearchConditionModal}
        setOpen={() => {
          setStoredSearchConditionModal((prev) => !prev);
        }}
        onSearchLogClick={(searchLog) => {
          try {
            setLoadingSearch(true);
            setSearchContext(searchLog.memo);
            const stringCountry = searchLog.country;
            const validJsonString = stringCountry.replace(/'/g, '"');

            // Parse the JSON string
            const country = JSON.parse(validJsonString);
            setResult([]);

            const payload = {
              freeText: searchLog.freeWord,
              country: country,
              sdgs: searchLog?.sdgs?.edges?.map((edge) => edge.node.id) ?? [],
              activityFields:
                searchLog?.activityFields?.edges?.map((edge) => edge.node.id) ??
                [],
              collaborationNeeds:
                searchLog?.collaborationNeeds?.edges?.map(
                  (edge) => edge.node.id
                ) ?? [],
              stakeholders:
                searchLog?.targets?.edges?.map((edge) => edge.node.id) ?? [],
              revenueCategories:
                searchLog?.revenueCategory?.edges?.map(
                  (edge) => edge.node.id
                ) ?? [],
              networks:
                searchLog?.networks?.edges?.map((edge) => edge.node.id) ?? [],
              certifications:
                searchLog?.thirdPartyCertifications?.edges?.map(
                  (edge) => edge.node.id
                ) ?? [],
            };
            setSearchInput(payload);
            setStoredSearchConditionModal(false);
            setTimeout(() => {
              fetchSearchResult({
                variables: {
                  ...generateFilterContext(
                    payload,
                    country?.map((item) => item.id)
                  ),
                  first: 8,
                  after: "",
                },
              }).then(() => {
                setLoadingSearch(false);
              });
            }, 200);
          } catch (err) {
            console.log(err);
            setLoadingSearch(false);
          }
        }}
      />
      <Row className="mt-3">
        <Col xs={12}>
          想定している条件を選んでCSO
          を検索してみましょう（すべてを選択する必要はありません）
        </Col>
      </Row>
      <Row
        className="mt-3"
        style={{
          gap: "24px",
        }}
      >
        <Col
          xs={12}
          lg={7}
          style={{
            paddingRight: "15px",
            marginBottom: "32px",
          }}
        >
          <div
            style={{
              borderBottom: "1px solid #9A9A9A",
              paddingBottom: "12px",
            }}
          >
            <div className="buttons_container">
              {/* Store Search Condition Button */}
              <Button
                style={{
                  backgroundColor: "#134693",
                }}
                className="button_item"
                onClick={() => {
                  console.log("search", searchInput);
                  setStoreSearchConditionModal(true);
                }}
              >
                検索条件の保存
              </Button>
              {/* Edit Search Condition Button */}
              <Button
                style={{
                  backgroundColor: "#134693",
                }}
                className="button_item"
                onClick={() => {
                  setStoredSearchConditionModal(true);
                }}
              >
                検索条件の変更
              </Button>
              <div
                className="button_item"
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "8px",
                }}
              >
                <Button
                  style={{
                    backgroundColor: "#134693",
                  }}
                  className="button_item"
                  onClick={() => {
                    // getSupporterInfo();
                    handleSearchSupporterData();
                  }}
                >
                  あなたの連携方針
                </Button>
                <Button
                  id="collaboration-policy"
                  style={{
                    backgroundColor: "transparent",
                    color: "#000",
                    fontSize: "22px",
                    padding: "0px",
                    border: "none",
                    marginTop: "4px",
                  }}
                  onClick={toggle}
                >
                  <i className="pe-7s-help1" />
                </Button>
              </div>
              <Popover
                target="collaboration-policy"
                toggle={toggle}
                isOpen={popoverOpen}
                placement="right"
              >
                <PopoverBody>連携方針に対する説明</PopoverBody>
              </Popover>
            </div>
            <div>
              <textarea
                id="context"
                name="メモ"
                placeholder="メモとして利用できます"
                style={{
                  width: "100%",
                  height: "100px",
                  padding: "16px",
                  border: "1px solid #B9B9B9",
                  borderRadius: "4px",
                }}
                onChange={(e) => {
                  setSearchContext(e.target.value);
                }}
                value={searchContext}
              />
            </div>
          </div>
          <div
            style={{
              padding: "16px",
            }}
          >
            <Row
              style={{
                display: "flex",
              }}
            >
              <div
                style={{
                  display: "flex",
                  flexGrow: 1,
                }}
              >
                <div style={{ width: "100%" }}>
                  <Input
                    id="freeText"
                    name="freeText"
                    placeholder="フリーワード"
                    type="text"
                    onChange={handleChangeFreeText}
                    defaultValue={searchInput.freeText}
                    value={searchInput.freeText}
                  />
                </div>
                <Button
                  style={{
                    backgroundColor: "transparent",
                    color: "#000",
                    border: "none",
                    height: "38px",
                    whiteSpace: "nowrap",
                  }}
                  onClick={() => {
                    setSearchInput(searchInputInitialState);
                    setSearchContext("");
                    setResult([]);
                  }}
                >
                  <i class="pe-7s-refresh"></i>
                  <span
                    style={{
                      marginLeft: "6px",
                    }}
                  >
                    リセット
                  </span>
                </Button>
              </div>
              <Button
                className="button_item search_button"
                style={{
                  backgroundColor: "#134693",
                  height: "38px",
                }}
                onClick={() => {
                  try {
                    setResult([]);
                    setLoadingSearch(true);
                    setPaginateOptions({
                      after: "",
                      first: 8,
                    });
                    fetchSearchResult({
                      variables: {
                        ...generateFilterContext(searchInput),
                        first: 8,
                        after: "",
                      },
                    }).then(() => {
                      setLoadingSearch(false);
                    });
                  } catch (err) {
                    console.error(err);
                    setLoadingSearch(false);
                  }
                }}
              >
                検索
              </Button>
            </Row>
            <Row>
              <div
                style={{
                  width: "100%",
                  marginTop: "20px",
                }}
              >
                <FormGroup>
                  <Label>活動国から選ぶ</Label>
                  <Multiselect
                    dataKey="id"
                    textField="nameJp"
                    placeholder="▼ 選択"
                    value={searchInput.country}
                    data={(() => {
                      const selectedIds = searchInput?.country?.map(
                        (item) => item.id
                      );
                      return availableCountries?.data?.countries?.edges
                        ?.filter((item) => {
                          return !selectedIds?.includes(item?.node?.id);
                        })
                        ?.map((country) => {
                          return {
                            nameJp: country?.node?.nameJp,
                            id: country?.node?.id,
                          };
                        });
                    })()}
                    onChange={(e) => {
                      setSearchInput((prev) => ({
                        ...prev,
                        country: e,
                      }));
                    }}
                  />
                </FormGroup>
              </div>
            </Row>
          </div>
          {filterItems.map((filterItem, idx) => {
            if (!filterItem.visible) return null;
            return (
              <div
                key={idx}
                style={{
                  ...(idx !== 0 && {
                    marginTop: "29px",
                  }),
                }}
              >
                <h2
                  style={{
                    color: "#8D8D8D",
                    fontSize: "12px",
                  }}
                >
                  {filterItem.label}
                </h2>
                <div
                  style={{
                    marginTop: "2px",
                  }}
                >
                  {filterItem.options?.map((filterItemOption) => {
                    return (
                      <FilterItemChip
                        key={filterItemOption.value}
                        label={filterItemOption.label}
                        active={searchInput?.[filterItem?.name]?.includes(
                          filterItemOption.value
                        )}
                        onClick={() => {
                          handleClickFilterItem({
                            filterName: filterItem.name,
                            filterValue: filterItemOption.value,
                          });
                        }}
                      />
                    );
                  })}
                </div>
              </div>
            );
          })}
        </Col>
        <Col
          xs={12}
          lg={4}
          style={{
            border: "1px solid #B9B9B9",
            borderRadius: "4px",
            padding: "32px 16px",
            maxHeight: "calc(100vh - 200px)",
            overflowY: "auto",
          }}
        >
          {!loadingSearch &&
            result?.map((cso) => (
              <CsoResult
                cso={cso}
                key={cso.id}
                onCsoWishCreated={onCsoWishCreated}
                onCsoWishDeleted={onCsoWishDeleted}
                canEdit={canEdit}
              />
            ))}
          {loadingSearchResult || loadingSearch ? (
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                width: "100%",
              }}
            >
              <img
                style={{ width: "80px", margin: "auto" }}
                src={animetionLogo}
              ></img>
            </div>
          ) : null}
          {!loadingSearch &&
            dataSearchResult?.searchOrg?.pageInfo?.hasNextPage && (
              <button
                style={{
                  margin: "auto",
                  marginTop: "16px",
                  padding: "9px",
                  width: "100%",
                  backgroundColor: "#F1F4F6",
                  border: "1px solid #495057",
                  borderRadius: "5px",
                }}
                onClick={() => {
                  fetchSearchResult({
                    variables: {
                      ...generateFilterContext(searchInput),
                      first: 8,
                      after: dataSearchResult.searchOrg.pageInfo.endCursor,
                    },
                  });
                }}
              >
                さらに表示する
              </button>
            )}
        </Col>
      </Row>
    </Fragment>
  );
};

export default SearchCSO;
